webpackJsonp([262886178365365],{

/***/ 1792:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"FileResults","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"files","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"LIST","name":null,"ofType":{"kind":"NON_NULL","name":null,"ofType":{"kind":"OBJECT","name":"File"}}}}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"nextPageToken","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-file-results-433e5983706f1aa8b6a3.js